var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "500" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "allinea-rose" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "warning headline" },
                [
                  !_vm.isSquadreAllineate
                    ? _c("span", { staticClass: "white--text" }, [
                        _vm._v("Disallineamento squadre"),
                      ])
                    : !_vm.isCalciatoriAllineati
                    ? _c("span", { staticClass: "white--text" }, [
                        _vm._v("Disallineamento rose"),
                      ])
                    : _c("span", { staticClass: "white--text" }, [
                        _vm._v("Riallineamento rose/crediti"),
                      ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        fab: "",
                        depressed: "",
                        outlined: "",
                        small: "",
                        color: "white",
                      },
                      on: { click: _vm.retry },
                    },
                    [_c("v-icon", [_vm._v("sync")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pa-4" }, [
                !_vm.isSquadreAllineate
                  ? _c(
                      "div",
                      [
                        _c("v-icon", { staticClass: "mr-2 error--text" }, [
                          _vm._v("warning"),
                        ]),
                        _vm._v(
                          "\n          C'è un disallineamento tra le squadre iscritte alla lega e quelle\n          attualmente visibili in Asta Live\n        "
                        ),
                      ],
                      1
                    )
                  : !_vm.isCalciatoriAllineati
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("v-icon", { staticClass: "pa-4" }, [
                            _vm._v("warning"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(
                        "\n          C'è un disallineamento tra le rose in Asta Live e quelle su\n          app/sito"
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("strong", [_vm._v("Tranquillo è normale")]),
                      _vm._v(
                        ": semplicemente avete fatto dei\n          movimenti di mercato o modificato manualmente dei crediti al di\n          fuori di Asta Live.\n        "
                      ),
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n          Vuoi forzare un riallineamento di rose e crediti con quelle che vedi\n          sul sito/app?\n        "
                      ),
                    ]),
                _vm._v(" "),
                !_vm.isCalciatoriAllineati
                  ? _c("div", { staticClass: "table-comparisons" }, [
                      _c(
                        "table",
                        { class: { "nice-scroll": !_vm.is_mobile } },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th"),
                              _vm._v(" "),
                              _c("th", [_vm._v("Asta Live")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("App/Sito")]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.comparisons,
                              function (obj, id_calciatore) {
                                return _c("tr", { key: id_calciatore }, [
                                  _c("td", [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.calciatori[id_calciatore]
                                            .calciatore
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-left align-center",
                                      },
                                      [
                                        obj.pre
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.asta_squadre[
                                                      obj.pre.squadra_id
                                                    ].name
                                                  ) +
                                                  " (" +
                                                  _vm._s(obj.pre.p) +
                                                  ")\n                    "
                                              ),
                                            ])
                                          : _c("div", [_vm._v("Svincolato")]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-left align-center",
                                      },
                                      [
                                        obj.post
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.asta_squadre[
                                                      obj.post.squadra_id
                                                    ].name
                                                  ) +
                                                  " (" +
                                                  _vm._s(obj.post.p) +
                                                  ")\n                    "
                                              ),
                                            ])
                                          : _c("div", [_vm._v("Svincolato")]),
                                      ]
                                    ),
                                  ]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-center align-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { rounded: "", depressed: "", color: "warning" },
                      on: { click: _vm.allineaRose },
                    },
                    [_vm._v("\n          Riallinea\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }